import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getMerchantAccountCredentials } from 'config/requests/merchants';

export const useMerchantAccountCredentials = (id: string | undefined, enabled = true) => {
  const { data: credentials, isLoading } = useQuery({
    queryKey: [`${Resources.MerchantAccounts}/credentials`, id],
    queryFn: () => getMerchantAccountCredentials(id!),
    enabled: Boolean(id) && enabled,
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });

  return { credentials, isLoading };
};
